import { WebCoreSensitiveSettings } from '@lmnop/web-core';
import { IWebsiteCoreSensitiveSettings } from './website-core-sensitive-settings.interface';

export class WebsiteCoreSensitiveSettings extends WebCoreSensitiveSettings implements IWebsiteCoreSensitiveSettings {
    constructor() {
        super();
    }

    public websiteSensitive: boolean;

    public override init() {
        super.init();
    }

    public override setDefaultValues(): void {
        super.setDefaultValues();
        this.websiteSensitive = true;
    }

    public override translateDefaultValues(): void {
        super.translateDefaultValues();
    }
}
